<template>
  <div class="dashboard">
    <!-- 顶部导航栏 -->
    <div class="head_info">
      <span @click="pushAddBoost()"> 新建助推 </span>
    </div>
    <!-- 选项模块 -->
    <div class="choosModelList">
      <!-- 推广场景 -->
      <div class="choosModel">
        <span>推广场景</span>
        <div class="models">
          <div
            v-for="item in pushScenario"
            :key="item.id"
            :class="{ activeDiv: item.id === 2 }"
            class="modelItem"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <!-- 选择广告位 -->
      <div class="choosModel">
        <span>选择广告位</span>
        <div class="models">
          <div
            v-for="item in pushScenario2"
            :key="item.id"
            :class="{ activeDiv: item.id === 1 }"
            class="modelItem"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <!-- 优化目标及出价 -->
      <div class="choosModel">
        <span>优化目标及出价</span>
        <div class="models">
          <selector-dropdown
            style="background-color: #fff; padding: 0; width: 76px"
            v-model="parameter.unitChargeType"
            :options="forDer"
            placeholder="请选择"
            :clear-on-cancel="true"
            :cancelText="''"
          />
          <van-field
            class="enter-input"
            type="number"
            v-model="parameter.unitPrice"
            @blur="handleBlur"
            :placeholder="inputText"
          />
        </div>
      </div>
      <!-- 深度优化目标及出价 -->
      <div class="choosModel" v-if="parameter.unitChargeType === '104'">
        <span>深度优化目标及出价</span>
        <div class="models">
          <selector-dropdown
            style="background-color: #fff; padding: 0; width: 76px"
            v-model="parameter.deepUnitChargeType"
            :options="DeepforDer"
            placeholder="请选择"
            :clear-on-cancel="true"
            :cancelText="''"
            @change="handleDeepSortChange"
          />
          <van-field
            class="enter-input"
            v-if="parameter.deepUnitChargeType == '7'"
            type="number"
            v-model="parameter.deepUnitPrice"
            @blur="handleDeepBlur"
            :placeholder="DeepinputText"
          />
        </div>
      </div>

      <!-- 暗户ID -->
      <div class="choosModel" v-if="selectedCountList.length < 2">
        <span>暗户ID</span>
        <div class="models">
          <selector-dropdown
            style="background-color: #fff; padding: 0; width: 76px"
            v-model="parameter.manualAccountId"
            :options="DarkListData"
            placeholder="请选择暗户ID"
            :clear-on-cancel="true"
            :cancelText="''"
            @change="handleManualChange"
          />
        </div>
      </div>
      <!-- 投放人群 -->
      <div class="choosModel">
        <span>投放人群</span>
        <div class="models">
          <div
            v-for="(item, idx) in LaunchCrowd"
            :key="item.id"
            @click="handleLaunchCrowd(idx)"
            :class="{ activeDiv: item.boller }"
            class="crowd"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <!-- 下边是投放人群自定义模块 -->
      <!-- 地域 -->
      <div class="choosModel" v-if="LaunchCrowd[1].boller">
        <span>地域</span>
        <div class="models">
          <div
            v-for="(item, idx) in addressList"
            :key="item.id"
            @click="handleLaunchAddress(idx)"
            :class="{ activeDiv: item.id === 1 }"
            class="notcrowd"
          >
            {{ item.name }}
          </div>
          <van-field
            class="fieldValue"
            v-if="false"
            v-model="fieldValue"
            is-link
            readonly
            placeholder="请选择或搜索地区"
            @click="show = true"
          />
        </div>
      </div>
      <!-- 性别 -->
      <div class="choosModel" v-if="LaunchCrowd[1].boller">
        <span>性别</span>
        <div class="models">
          <div
            v-for="(item, idx) in sexChoose"
            :key="item.id"
            @click="handleSexChoose(idx)"
            :class="{ activeDiv: item.boller }"
            class="crowd"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <!-- 年龄 -->
      <div class="choosModel" v-if="LaunchCrowd[1].boller">
        <span>年龄</span>
        <div class="models">
          <div
            v-for="(item, idx) in ageChoose"
            :key="item.id"
            @click="handleAgeChoose(idx)"
            :class="{ activeDiv: item.boller }"
            class="crowd"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <!-- 自定义人群 -->
      <div class="choosModel" v-if="LaunchCrowd[1].boller">
        <span>自定义人群</span>
        <div class="models">
          <div
            v-for="(item, idx) in numPeople"
            :key="item.id"
            @click="handleNumPeople(idx)"
            :class="{ activeDiv: item.id === 1 }"
            class="notcrowd"
          >
            {{ item.name }}
          </div>
          <picker-selector-check
            v-if="false"
            :textFiled="'定向:'"
            class="PeopleValue"
            v-model="parameter.productId"
            :options="allProducts"
            placeholder="全部产品"
            @change="handleProductSelect"
          />
        </div>
      </div>
      <!-- 操作系统 -->
      <div class="choosModel" v-if="LaunchCrowd[1].boller">
        <span>操作系统</span>
        <div class="models">
          <div
            v-for="(item, idx) in OSChoose"
            :key="item.id"
            @click="handleOSChoose(idx)"
            :class="{ activeDiv: item.boller }"
            class="crowd"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <!-- 投放时长 -->
      <div class="choosModel">
        <span>投放时长</span>
        <div class="models">
          <div
            v-for="(item, idx) in putTimeChoose"
            :key="item.id"
            @click="handleTimeChoose(idx)"
            :class="{ activeDiv: item.boller }"
            class="crowd"
          >
            {{ item.name }}
          </div>
          <van-field
            class="putTime-input"
            v-if="putTimeInpShow"
            type="number"
            v-model="dayTime"
            @blur="handleBlurPutTime"
            :placeholder="PutTimeinputs"
          />
          <selector-dropdown
            v-if="putTimeInpShow"
            style="background-color: #fff"
            v-model="PutTimeValuesA"
            :options="PutTimeforDer"
            placeholder="请选择"
            :clear-on-cancel="true"
            :cancelText="''"
            @change="handlePutTimeChange"
          />
        </div>
      </div>
      <!-- 投放金额 -->
      <div class="choosModel">
        <span>投放金额</span>
        <div class="models">
          <div
            v-for="(item, idx) in moneyChoose"
            :key="item.id"
            @click="handleMoneyChoose(idx)"
            :class="{ activeDiv: item.boller }"
            class="crowd"
          >
            {{ item.name }}
          </div>
          <van-field
            class="putTime-input"
            v-if="moneyInpShow"
            type="number"
            v-model="parameter.amount"
            @blur="handleBlurMoneyNum"
            :placeholder="MonerNuminputs"
            ><template #right-icon>
              <span style="font-weight: 400">元</span>
            </template></van-field
          >
        </div>
      </div>
      <!-- 计划投放 -->
      <div class="choosModel">
        <span>计划投放</span>
        <div class="models">
          <selector-dropdown
            style="background-color: #fff; padding: 0; width: 76px"
            v-model="parameter.uploadCount"
            :options="PlannedforDer"
            placeholder="请选择"
            :clear-on-cancel="true"
            :cancelText="''"
          />
          <div
            v-for="(item, idx) in PlannedChoose"
            :key="item.id"
            @click="handlePlannedChoose(idx)"
            :class="{ activeDiv: item.boller }"
            class="crowd"
            :style="{ width: item.id == 2 ? '87px' : '67px' }"
          >
            {{ item.name }}
          </div>
          <!-- <template v-if="PlannedChoose[0].boller">
            <div style="width: 20%; text-align: left; background: none">
              上线时间
            </div>
            <van-radio-group
              v-model="Plannedradio"
              style="width: 60%; background: none"
            >
              <van-radio name="1" shape="square" style="margin-bottom: 10px"
                >立即发布</van-radio
              >
              <van-radio name="2" shape="square">指定时间上线</van-radio>
            </van-radio-group>
           
            <van-popup
              v-model="Dateshow"
              position="bottom"
              :style="{ height: '50%', width: '100%' }"
            >
              <van-datetime-picker
                @confirm="confirmdate"
                style="width: 100%"
                v-model="currentDate"
                type="datetime"
                title="选择完整时间"
                :min-date="minDate"
                :max-date="maxDate"
              />
            </van-popup>

            <div
              style="
                width: 20%;
                text-align: left;
                background: none;
                margin-bottom: 10px;
              "
            >
              下线时间
            </div>
            <van-radio-group
              v-model="Plannedradio2"
              style="width: 60%; background: none"
            >
              <van-radio name="1" shape="square" style="margin-bottom: 10px"
                >预定时间到期自动下线</van-radio
              >
              <van-radio name="2" shape="square">指定时间下线</van-radio>
            </van-radio-group>
          </template> -->
        </div>
      </div>
      <!-- 智能预警 -->
      <div class="choosModel">
        <span>智能预警</span>
        <van-row>
          <van-col span="6">
            <div>状态</div>
          </van-col>
          <van-col span="18"
            ><van-switch @change="changeSwitch" v-model="checked" size="16px"
          /></van-col>
        </van-row>
        <van-row>
          <van-col span="6">
            <div>触发条件</div>
          </van-col>
          <van-col span="8"><span>消耗金额/预算金额≥</span></van-col>
          <van-col span="10"
            ><van-field
              v-model="parameter.forewarning"
              type="digit"
              class="putTime-input"
              ><template #right-icon>
                <span style="font-weight: 400">%</span>
              </template></van-field
            ></van-col
          >
        </van-row>
        <van-row>
          <van-col span="6">
            <div>发送频率</div>
          </van-col>
          <van-col span="13"
            ><selector-dropdown
              style="background-color: #fff; padding: 0"
              v-model="parameter.warningFrequency"
              :options="frequencyforDer"
              placeholder="请选择"
              :clear-on-cancel="true"
              :cancelText="''"
              @change="handlePineLvChange"
          /></van-col>
        </van-row>
      </div>
      <!-- 支付信息 -->
      <div class="choosModel">
        <span>支付信息</span>
        <van-row>
          <van-col span="6">
            <div>助推订单*{{ parameter.uploadCount * selectedCount || 0 }}</div>
          </van-col>
          <van-col span="18">
            <div>
              金额：<span style="color: red"
                >￥{{
                  moneyResult !== 1
                    ? parameter.uploadCount * selectedCount * moneyResult
                    : parameter.uploadCount * selectedCount * parameter.amount
                }}</span
              >
            </div>
          </van-col>
        </van-row>
      </div>
      <!-- 支付方式 -->
      <div class="choosModel">
        <span>支付方式</span>
        <div class="models">
          <div
            v-for="(item, idx) in PayChoose"
            :key="item.id"
            @click="handlePayChoose(idx)"
            :class="{ activeDiv: item.boller }"
            class="crowd"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
    <div class="affirm">
      <a href="#" @click="goON">上一步</a>
      <van-button type="primary" @click="PushaddBoost">确认支付</van-button>
    </div>
    <van-popup v-model="show" round position="bottom">
      <van-cascader
        v-model="cascaderValue"
        title="请选择地区"
        :options="options"
        @close="show = false"
        @finish="onFinish"
      />
    </van-popup>
  </div>
</template>

<script>
import SelectorDropdown from "@/components/SelectorDropdown.vue";
import PickerSelectorCheck from "@/components/PickerSelectorCheck.vue";
import {
  getaddBoostList,
  BatchBuy,
  getManualListData,
} from "@/api/modules/addBoost";
export default {
  name: "AddBoostPage",
  components: {
    SelectorDropdown,
    PickerSelectorCheck,
  },
  data() {
    return {
      Dateshowvalue: "",
      Dateshow: false,
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      checked: true,
      Plannedradio: "1", //上线时间
      Plannedradio2: "1", //上线时间
      moneyInpShow: false,
      putTimeInpShow: false,
      pushScenario: [
        { id: 1, name: "提升视频热度" },
        { id: 2, name: "提升应用安装" },
        { id: 3, name: "提升应用活跃" },
      ],
      pushScenario2: [
        { id: 1, name: "信息流广告" },
        { id: 2, name: "激励视频" },
      ],
      SortValuesA: "104",
      inputText: "出价范围:0.5-10000",
      // 优化目标及出价选择器选项
      forDer: [
        { name: "激活数", value: "104" },
        { name: "行为数", value: "105" },
        { name: "付费", value: "121" },
      ],
      dayTime: "48",
      PutTimeValuesA: "hour",
      PutTimeinputs: "投放时间范围为: 1-24小时",
      // 投放时长选择器选项
      PutTimeforDer: [
        { name: "小时", value: "hour" },
        { name: "天", value: "day" },
      ],
      MonerNuminputs: "不小于500,不大于10,000,000",
      DeepinputText: "出价范围:1-10000",
      // 深度优化目标及出价选择器选项
      DeepforDer: [
        { name: "无", value: "0" },
        { name: "自然日次留存", value: "7" },
      ],
      // 发生频率
      frequencyforDer: [
        { name: "2分钟", value: "2" },
        { name: "5分钟", value: "5" },
        { name: "30分钟", value: "10" },
        { name: "1小时", value: "60" },
        { name: "3小时", value: "180" },
        { name: "6小时", value: "360" },
      ],
      PlannedValuesA: "1",
      // 计划投放条数
      PlannedforDer: [
        { name: "1", value: "1" },
        { name: "2", value: "2" },
        { name: "3", value: "3" },
        { name: "4", value: "4" },
        { name: "5", value: "5" },
        { name: "6", value: "6" },
        { name: "7", value: "7" },
        { name: "8", value: "8" },
      ],
      allProducts: [],
      allAdvert: [],
      DarkListData: [], //暗户id
      parameter: {
        // pageNo: 1,
        // pageSize: 20,
        // productId: "111",
        // supplementOrderId: "",
        // orderBy: "",
        // putTime: '',
        // moneyNum: '',
        // uploadType: '',
        // endType: '',

        campaignType: "30",
        supplementOrderSenseId: "30",
        unitChargeType: "104",
        promotionDuration: "48",
        amount: "3000",
        payMethod: "4",
        gender: "2",
        uploadCount: "1",
        multiAges: [],
        warningStatus: "1",
        forewarning: "70",
        warningFrequency: "2",
        custom: "1",
        platform: "0",
        regionType: "",
        targetType: "1",
        deepUnitChargeType: "0",
        uploadType: "0",
        endType: "1", // 结束类型传值： 1
        unitPriceType: 1,
      },
      LaunchCrowd: [
        { id: 1, name: "智能定向", value: "1", boller: true },
        { id: 2, name: "自定义定向", value: "2", boller: false },
      ], //投放人群选择项
      addressList: [
        { id: 1, name: "不限", boller: false },
        { id: 2, name: "指定地区", boller: true },
        { id: 3, name: "城市等级", boller: false },
      ], //投放人群选择项
      sexChoose: [
        { id: 1, name: "不限", boller: false, value: "0" },
        { id: 2, name: "男", boller: true, value: "2" },
        { id: 3, name: "女", boller: false, value: "1" },
      ], //投放人群选择项
      ageChoose: [
        { id: 1, name: "不限", boller: false, value: "" },
        { id: 2, name: "18-23", boller: true, value: "18-23" },
        { id: 3, name: "24-30", boller: false, value: "24-30" },
        { id: 4, name: "31-40", boller: false, value: "31-40" },
        { id: 5, name: "41-50", boller: false, value: "41-50" },
        { id: 6, name: "50+", boller: false, value: "50+" },
      ], //投放人群选择项
      numPeople: [
        { id: 1, name: "不限", boller: false },
        { id: 2, name: "定向", boller: true },
        { id: 3, name: "排除", boller: false },
      ], //投放人群选择项
      OSChoose: [
        { id: 1, name: "不限", boller: true, value: "0" },
        { id: 2, name: "iOS", boller: false, value: "1" },
        { id: 3, name: "Android", boller: false, value: "2" },
      ], //投放人群选择项
      putTimeChoose: [
        { id: 24, name: "24小时", boller: false },
        { id: 48, name: "2天", boller: true },
        { id: 98, name: "7天", boller: false },
        { id: 4, name: "自定义", boller: false },
      ], //投放人群选择项
      moneyChoose: [
        { id: 1, name: "2000", boller: false },
        { id: 2, name: "3000", boller: true },
        { id: 3, name: "5000", boller: false },
        { id: 4, name: "自定义", boller: false },
      ], //投放人群选择项
      PlannedChoose: [
        { id: 1, name: "立即发布", boller: true },
        // { id: 2, name: "上下线自动控制", boller: true },
      ], //投放人群选择项
      PayChoose: [
        { id: 1, name: "现金金额", boller: false, value: "1" },
        { id: 2, name: "现金+流量", boller: false, value: "2" },
        { id: 3, name: "代理商余额", boller: false, value: "3" },
        { id: 4, name: "代理商+流量", boller: true, value: "4" },
      ], //投放人群选择项
      show: false,
      fieldValue: "",
      cascaderValue: "",
      // 选项列表，children 代表子选项，支持多级嵌套
      options: [
        {
          text: "浙江省",
          value: "330000",
          children: [{ text: "杭州市", value: "330100" }],
        },
        {
          text: "江苏省",
          value: "320000",
          children: [{ text: "南京市", value: "320100" }],
        },
      ],
      selectedCount: 0, //跳转过来携带的条数
      moneyResult: 3000, //金额
      dateValue: "", //日期
      selectedCountList: [],
    };
  },
  async created() {
    this.selectedCount = this.$route.params.selectedCount;
    console.log("this.array", this.$route.params.array);

    this.selectedCountList = this.$route.params.array;
    this.parameter.ksAdSocialOrders = this.selectedCountList.map((item) => ({
      advertiserId: item.advertiserId,
      orderIds: [item.orderId],
    }));
    // await this.loadProducts(); // 加载产品数据
  },
  methods: {
    handlePineLvChange() {},
    goON() {
      this.$router.push({
        name: "newBoost",
        params: { fromName: "addBoost" },
      });
    },
    async PushaddBoost() {
      const res = await BatchBuy(this.parameter);
      if (res.result) {
        this.$router.push({ name: "newBoost" });
      } else {
        this.$message.error("创建失败");
      }
      // console.log('确认支付后的结果',res);
      // console.log(this.parameter);
    },
    confirmdate(value) {
      console.log(value);
      this.Dateshow = false;
      this.dateValue = value;
    },
    // 获取产品列表
    async loadProducts() {
      const res = await getaddBoostList({
        type: "0",
        status: "0",
      });
      console.log(res);
      this.allProducts = res.list.map((item) => ({
        label: item.populationName,
        value: item.id,
      }));
    },
    // 优化目标及出价选择
    handleSortChange() {
      this.parameter.deepUnitChargeType = "0";
      this.parameter.unitPrice = "";
      // 定义一个映射表，将 SortValuesA 对应的出价范围直接映射到 inputText
      const sortRanges = {
        104: "出价范围:0.5-10000",
        105: "出价范围:0.1-10000",
        121: "出价范围:5-10000",
      };
      // 使用映射表直接设置 inputText
      this.inputText = sortRanges[this.parameter.unitChargeType] || "";
    },
    // 投放时长
    handlePutTimeChange() {
      this.parameter.promotionDuration = "";
      // 定义一个映射表，将 SortValuesA 对应的出价范围直接映射到 inputText
      const sortRanges = {
        hour: "投放时间范围为: 1-24小时",
        day: "投放时间范围为: 2-14天",
      };
      // 使用映射表直接设置 inputText
      this.PutTimeinputs = sortRanges[this.PutTimeValuesA] || "";
    },
    // 深度优化目标及出价输入框失焦
    handleDeepBlur(e) {
      const value = parseFloat(e.target.value); // 确保 value 是数字
      // 如果转换失败，退出函数
      if (isNaN(value)) {
        return;
      }
      // 根据 SortValuesA 的不同值设置对应的上下限
      const limits = {
        7: { min: 1, max: 10000 },
      };
      // 获取对应的限制
      const limit = limits[this.parameter.deepUnitChargeType];
      // 确保 limit 存在
      if (limit) {
        // 根据条件设置 orderId
        if (value <= limit.min) {
          this.parameter.deepUnitPrice = limit.min.toFixed(2);
        } else if (value >= limit.max) {
          this.parameter.deepUnitPrice = limit.max.toFixed(2);
        } else {
          this.parameter.deepUnitPrice = value.toFixed(2);
        }
      }
    },
    // 深度优化目标及出价选择
    handleDeepSortChange() {
      if (this.parameter.deepUnitChargeType == "7") {
        this.inputText = "出价范围：1-1000";
        if (this.parameter.unitPrice && this.parameter.unitPrice <= 1) {
          this.parameter.unitPrice = (1).toFixed(2);
        }
      } else {
        this.inputText = "出价范围：0.5-10000";
      }
    },
    // 优化目标及出价输入框失焦
    handleBlur(e) {
      const value = parseFloat(e.target.value); // 确保 value 是数字
      // 如果转换失败，退出函数
      if (isNaN(value)) {
        return;
      }
      // 根据 SortValuesA 的不同值设置对应的上下限
      const limits = {
        consume_amount: {
          min: this.parameter.deepUnitChargeType == "7" ? 1 : 0.5,
          max: this.parameter.deepUnitChargeType == "7" ? 1000 : 10000,
        },
        conversion: { min: 0.1, max: 10000 },
        remaining_date: { min: 5, max: 10000 },
      };
      // 获取对应的限制
      const limit = limits[this.parameter.unitChargeType];
      // 确保 limit 存在
      if (limit) {
        // 根据条件设置 orderId
        if (value <= limit.min) {
          this.parameter.unitPrice = limit.min.toFixed(2);
        } else if (value >= limit.max) {
          this.parameter.unitPrice = limit.max.toFixed(2);
        } else {
          this.parameter.unitPrice = value.toFixed(2);
        }
      }
    },
    // 投放时长失焦
    handleBlurPutTime(e) {
      const value = parseFloat(e.target.value); // 确保 value 是数字
      // 如果转换失败，退出函数
      if (isNaN(value)) {
        return;
      }
      // 根据 PutTimeValuesA 的不同值设置对应的上下限
      const limits = {
        hour: { min: 1, max: 24 },
        day: { min: 2, max: 14 },
      };
      // 获取对应的限制
      const limit = limits[this.PutTimeValuesA];
      // 确保 limit 存在
      if (limit) {
        // 根据条件设置 orderId
        if (value <= limit.min) {
          this.dayTime = limit.min.toFixed(0);
        } else if (value >= limit.max) {
          this.dayTime = limit.max.toFixed(0);
        } else {
          this.dayTime = value.toFixed(0);
        }
      }

      if (this.PutTimeValuesA == "day") {
        this.parameter.promotionDuration = Number(this.dayTime * 24);
      } else {
        this.parameter.promotionDuration = this.dayTime;
      }
    },
    // 投放金额失焦
    handleBlurMoneyNum(e) {
      const value = parseFloat(e.target.value); // 确保 value 是数字
      // 如果转换失败，退出函数
      if (isNaN(value)) {
        return;
      }
      const limits = {
        min: 500,
        max: 10000000,
      };
      // 确保 limit 存在
      // 根据条件设置 orderId
      if (value <= limits.min) {
        this.parameter.amount = limits.min.toFixed(0);
      } else if (value >= limits.max) {
        this.parameter.amount = limits.max.toFixed(0);
      } else {
        this.parameter.amount = value.toFixed(0);
      }
    },
    // 投放人群选择
    handleLaunchCrowd(idx) {
      this.parameter.targetType = this.LaunchCrowd[idx].value;
      if (idx === 0) {
        this.parameter.gender = "";
        this.parameter.regionType = "";
        this.parameter.multiAges = [];
        this.parameter.platform = "";
        this.parameter.custom = "1";
      } else {
        this.parameter.gender = "2";
        this.parameter.regionType = "";
        this.parameter.multiAges = [];
        this.parameter.platform = "0";
        this.parameter.custom = "2";
      }
      this.LaunchCrowd = this.LaunchCrowd.map((item, index) => {
        if (index === idx) {
          return {
            ...item,
            boller: item.boller === false ? true : item.boller,
          };
        }
        return { ...item, boller: false }; // 其他索引的 boller 设置为 false
      });
      // this.LaunchCrowd[idx].boller = !this.LaunchCrowd[idx].boller;
    },
    // 投放地域选择
    handleLaunchAddress(idx) {
      this.addressList = this.addressList.map((item, index) => {
        if (index === idx) {
          // 只有当当前项的 boller 是 false 时，才反转
          return {
            ...item,
            boller: item.boller === false ? true : item.boller,
          };
        }
        return { ...item, boller: false }; // 其他索引的 boller 设置为 false
      });
    },
    // 性别选择
    handleSexChoose(idx) {
      this.parameter.gender = this.sexChoose[idx].value;
      this.sexChoose = this.sexChoose.map((item, index) => {
        if (index === idx) {
          // 只有当当前项的 boller 是 false 时，才反转
          return {
            ...item,
            boller: item.boller === false ? true : item.boller,
          };
        }
        return { ...item, boller: false }; // 其他索引的 boller 设置为 false
      });
    },
    changeSwitch(value) {
      console.log(value);
      if (value) {
        this.parameter.warningStatus = "1";
      } else {
        this.parameter.warningStatus = "";
      }
    },
    // 年龄选择
    handleAgeChoose(idx) {
      this.ageChoose = this.ageChoose.map((item, index) => {
        if (idx === 0) {
          // 如果选中第一个选项，第二个和第三个选项变为未选中
          if (index === 0) {
            // 第一个选项被选中后，不可取消
            if (!item.boller) {
              return { ...item, boller: true }; // 选中第一个选项
            } else {
              return item; // 如果第一个已经选中，保持选中状态
            }
          } else {
            return { ...item, boller: false }; // 第二个和第三个选项变为未选中
          }
        }
        // 如果选中第二个或第三个选项
        if (idx === 1 || idx === 2 || idx === 3 || idx === 4 || idx === 5) {
          if (index === 0) {
            return { ...item, boller: false }; // 第一个选项变为未选中
          } else if (index === idx) {
            return { ...item, boller: !item.boller }; // 切换当前选项的选中状态
          }
        }
        return item; // 返回未修改的项
      });
      // 检查是否所有选项都没有被选中，如果是，自动选中第一个选项
      if (this.ageChoose.every((item) => !item.boller)) {
        this.ageChoose[0] = { ...this.ageChoose[0], boller: true }; // 自动选中第一个选项
      }

      this.ageChoose.map((item) => {
        if (item.name == "不限" && item.boller == true) {
          this.parameter.multiAges = [];
        } else {
          this.parameter.multiAges = [];
          this.ageChoose.map((item) => {
            if (item.name !== "不限" && item.boller == true) {
              this.parameter.multiAges.push(item.value);
            }
          });
        }
      });

      console.log(this.ageChoose, this.parameter.multiAges);
    },
    // 自定义人群
    handleNumPeople(idx) {
      this.numPeople = this.numPeople.map((item, index) => {
        // 如果第一个选项被点击
        if (idx === 0) {
          // 如果选中第一个选项，第二个和第三个选项变为未选中
          if (index === 0) {
            // 第一个选项被选中后，不可取消
            if (!item.boller) {
              return { ...item, boller: true }; // 选中第一个选项
            } else {
              return item; // 如果第一个已经选中，保持选中状态
            }
          } else {
            return { ...item, boller: false }; // 第二个和第三个选项变为未选中
          }
        }
        // 如果选中第二个或第三个选项
        if (idx === 1 || idx === 2) {
          if (index === 0) {
            return { ...item, boller: false }; // 第一个选项变为未选中
          } else if (index === idx) {
            return { ...item, boller: !item.boller }; // 切换当前选项的选中状态
          }
        }
        return item; // 返回未修改的项
      });
      // 检查是否所有选项都没有被选中，如果是，自动选中第一个选项
      if (this.numPeople.every((item) => !item.boller)) {
        this.numPeople[0] = { ...this.numPeople[0], boller: true }; // 自动选中第一个选项
      }
    },
    // 支付方式选择
    handlePayChoose(idx) {
      // this.parameter.payMethod = this.PayChoose[idx].value;
      this.parameter.payMethod = "4";
      this.PayChoose = this.PayChoose.map((item, index) => {
        if (index === idx) {
          // 只有当当前项的 boller 是 false 时，才反转
          return {
            ...item,
            boller: item.boller === false ? true : item.boller,
          };
        }
        return { ...item, boller: false }; // 其他索引的 boller 设置为 false
      });
    },
    // 操作系统选择
    handleOSChoose(idx) {
      this.parameter.platform = this.OSChoose[idx].value;
      this.OSChoose = this.OSChoose.map((item, index) => {
        if (index === idx) {
          // 只有当当前项的 boller 是 false 时，才反转
          return {
            ...item,
            boller: item.boller === false ? true : item.boller,
          };
        }
        return { ...item, boller: false }; // 其他索引的 boller 设置为 false
      });
      // this.OSChoose = this.OSChoose.map((item, index) => {
      //   if (idx === 0) {
      //     if (index === 0) {
      //       if (!item.boller) {
      //         return { ...item, boller: true }; // 选中第一个选项
      //       } else {
      //         return item; // 如果第一个已经选中，保持选中状态
      //       }
      //     } else {
      //       return { ...item, boller: false }; // 第二个和第三个选项变为未选中
      //     }
      //   }
      //   if (idx === 1 || idx === 2) {
      //     if (index === 0) {
      //       return { ...item, boller: false }; // 第一个选项变为未选中
      //     } else if (index === idx) {
      //       return { ...item, boller: !item.boller }; // 切换当前选项的选中状态
      //     }
      //   }
      //   return item; // 返回未修改的项
      // });
      // // 检查是否所有选项都没有被选中，如果是，自动选中第一个选项
      // if (this.OSChoose.every(item => !item.boller)) {
      //   this.OSChoose[0] = { ...this.OSChoose[0], boller: true }; // 自动选中第一个选项
      // }
    },
    // 计划投放选择
    handlePlannedChoose(idx) {
      this.PlannedChoose = this.PlannedChoose.map((item, index) => {
        if (index === idx) {
          // 只有当当前项的 boller 是 false 时，才反转
          return {
            ...item,
            boller: item.boller === false ? true : item.boller,
          };
        }
        return { ...item, boller: false }; // 其他索引的 boller 设置为 false
      });
    },
    // 投放时长
    handleTimeChoose(idx) {
      if (idx !== 3) {
        this.dayTime = this.putTimeChoose[idx].id;
      } else {
        this.dayTime = "";
      }
      this.putTimeChoose = this.putTimeChoose.map((item, index) => {
        if (index === idx) {
          // 只有当当前项的 boller 是 false 时，才反转
          return {
            ...item,
            boller: item.boller === false ? true : item.boller,
          };
        }
        return { ...item, boller: false }; // 其他索引的 boller 设置为 false
      });
      if (idx === 3) {
        this.putTimeInpShow = true;
      } else {
        this.putTimeInpShow = false;
      }
    },
    // 投放金额
    handleMoneyChoose(idx) {
      if (idx !== 3) {
        this.parameter.amount = this.moneyChoose[idx].name;
      }
      if (idx !== 3) {
        this.moneyResult = this.moneyChoose[idx].name;
      } else {
        this.moneyResult = 1;
      }
      this.moneyChoose = this.moneyChoose.map((item, index) => {
        if (index === idx) {
          // 只有当当前项的 boller 是 false 时，才反转
          return {
            ...item,
            boller: item.boller === false ? true : item.boller,
          };
        }
        return { ...item, boller: false }; // 其他索引的 boller 设置为 false
      });
      if (idx === 3) {
        this.moneyInpShow = true;
      } else {
        this.moneyInpShow = false;
      }
    },
    // 年龄选择
    // 选择产品 根据产品筛选对应账户
    handleProductSelect() {
      // console.log(id);
      // this.parameter.productId = id;
    },
    // 跳转到测试页
    pushAddBoost() {
      this.$router.push({ name: "ceShi" });
    },
    // 地域选择全部选项选择完毕后，会触发 finish 事件
    onFinish({ selectedOptions }) {
      this.show = false;
      this.fieldValue = selectedOptions.map((option) => option.text).join("/");
    },
    // 获取暗户ID 列表
    async getManualList() {
      const res = await getManualListData({
        pageNo: 1,
        pageSize: 9999,
        advertiserId: this.selectedCountList[0]?.advertiserId,
      });
      this.DarkListData = res.data?.map((item) => ({
        name: item,
        value: item,
      }));
    },
  },

  mounted() {
    this.getManualList();
  },
};
</script>

<style scoped lang="scss">
.dashboard {
  height: 100vh;
  display: flex;
  flex-direction: column;

  .head_info {
    display: flex;
    justify-content: space-between;
    font-family: PingFang SC;
    font-weight: 600;
    font-size: 20px;
    line-height: 20px;
    margin: 30px 0 18px 0;
    padding-left: 12px;
    color: #000000;
  }

  .choosModelList {
    margin-left: 20px;
    padding-bottom: 20px;

    .choosModel {
      margin-top: 12px;

      .van-row {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-top: 10px;

        span {
          font-size: 12px;
          font-weight: 400;
        }
      }

      div {
        font-size: 12px;
        color: #000000;
      }

      span {
        color: #000000;
        font-family: PingFang SC;
        font-weight: 600;
        font-size: 14px;
        display: inline-block;
      }

      .putTime-input {
        width: 50%;
        border-radius: 2px;
        border: 1px solid #ded9d9;
        font-family: Inter;
        font-size: 12px;
        color: #000000;
        align-items: center;
        // margin: 5px 0;
        padding: 0 10px;
        box-sizing: border-box;
        background: #ffffff;
      }

      .models {
        // margin-top: 15px;
        display: flex;
        flex-direction: row;
        align-items: center;
        flex-wrap: wrap;

        ::v-deep .van-action-sheet {
          max-height: 33% !important;
        }

        .fieldValue {
          margin-top: 12px;
          width: 95%;
          background: #ffffff;
          border: 1px solid #ded9d9;
        }

        .PeopleValue {
          margin-top: 12px;
          width: 95%;
          background: #ffffff;
          padding: 0;
        }

        .enter-input {
          width: 50%;
          border-radius: 2px;
          border: 1px solid #ded9d9;
          font-family: Inter;
          font-size: 12px;
          color: #000000;
          align-items: center;
          // margin: 5px 0;
          padding: 0 10px;
          box-sizing: border-box;
          background: #ffffff;
        }

        .putTime-input {
          width: 70%;
          border-radius: 2px;
          border: 1px solid #ded9d9;
          font-family: Inter;
          font-size: 12px;
          color: #000000;
          align-items: center;
          // margin: 5px 0;
          padding: 0 10px;
          box-sizing: border-box;
          background: #ffffff;
        }

        .modelItem {
          color: #7e7e7e;
        }

        .crowd {
          border: 1px solid #d6d6d6;
          background: #fff;
        }

        .notcrowd {
          color: #7e7e7e;
        }

        .activeDiv {
          border: 1px solid #2575f2;
          color: #2575f2;
          background: #fff;
        }

        ::v-deep .selector-input {
          // width: 90px;
          height: 30px;
          // padding: 0 4px;
        }

        .plannedRio {
          width: 100%;
          padding: 0;
          background: none;
          display: flex;

          div:nth-child(1) {
            // width: 30%;
            text-align: left;
          }

          div:nth-child(2) {
            width: 70%;
          }
        }
      }

      .models > div {
        margin-top: 15px;
        width: 67px;
        height: 32px;
        padding: 0 4px;
        text-align: center;
        display: inline-block;
        line-height: 30px;
        border-radius: 2px;
        background: #f3f3f3;
        color: #000000;
        margin-right: 10px;
        font-size: 11px;
        cursor: pointer;
      }
    }
  }
  .affirm {
    padding: 10px 20px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .van-button {
      width: 125px;
      height: 41px;
      border-radius: 20px;
      color: #000000;
      background: #ffffff;
      box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.1),
        0px 0px 6px 0px rgba(0, 0, 0, 0.09), 0px 0px 8px 0px rgba(0, 0, 0, 0.05),
        0px 0px 9px 0px rgba(0, 0, 0, 0.01), 0px 0px 10px 0px rgba(0, 0, 0, 0);
      border-radius: 20px 20px 20px 20px;
      border: 1px solid #ffffff;
      margin-left: 15px;
    }
    a {
      font-family: Inter;
      font-weight: 400;
      font-size: 12px;
      color: #000000;
      line-height: 14px;
    }
  }
}
</style>
